import { useHistory } from 'react-router'
// type x<T> = {
//     sss: T
// }
const useRouter = () => {
    const routerHistory = useHistory()
    const goTo = <TParam extends unknown>(routePath: string, parameter?: TParam) => {
        routerHistory.push(routePath, parameter)
    }
    return { goTo }
}

export default useRouter
